import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

const SIGNUP_CONVERSION_PENDING_KEY = 'bpa.metaSignupConversion.pending';

@Injectable({ providedIn: 'root' })
export class MetaAdsService {
  private loaded = false;

  init(): void {
    const pixelId = environment.metaAds?.pixelId;
    if (!pixelId || this.loaded || typeof window === 'undefined') {
      return;
    }
    this.loaded = true;

    // Canonical Meta Pixel shim — MUST use `arguments` (not `...rest`) so the
    // Pixel loader sees a real Arguments object when it processes the queue.
    // Same trap as gtag in GoogleAdsService.
    const w = window as any;
    if (!w.fbq) {
      const fbq: any = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };
      w.fbq = fbq;
      if (!w._fbq) {
        w._fbq = fbq;
      }
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }

    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }

  markSignupConversionPending(): void {
    try {
      window.sessionStorage?.setItem(SIGNUP_CONVERSION_PENDING_KEY, '1');
    } catch {
    }
  }

  fireSignupConversionIfPending(): void {
    let pending = false;
    try {
      pending = window.sessionStorage?.getItem(SIGNUP_CONVERSION_PENDING_KEY) === '1';
      if (pending) {
        window.sessionStorage.removeItem(SIGNUP_CONVERSION_PENDING_KEY);
      }
    } catch {
    }

    if (!pending) {
      return;
    }

    const pixelId = environment.metaAds?.pixelId;
    const fbq = (window as any).fbq;
    if (!pixelId || typeof fbq !== 'function') {
      return;
    }

    fbq('track', 'CompleteRegistration');
    console.log('[MetaAds] CompleteRegistration fired');
  }
}
